<template>
    <va-create-layout>
        <RentalTransactionEventTaxWithheldCharge-form
            :title="title"
            :item="item"
        ></RentalTransactionEventTaxWithheldCharge-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
